import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
  apiKey:'6203771693ace8e855d3041bf746684c',
  plugins: [new BugsnagPluginVue(Vue)]
})
